var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRolesAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_roles_add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_roles_add",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#005082",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7793248,6.82677856 L10.7793248,10.7793248 L6.82677856,10.7793248 C6.15052451,10.7793248 5.6,11.3213046 5.6,12 C5.6,12.6738127 6.15052451,13.2206752 6.82677856,13.2206752 L10.7793248,13.2206752 L10.7793248,17.1732214 C10.7793248,17.8494755 11.3213046,18.4 12,18.4 C12.6738127,18.4 13.2206752,17.8494755 13.2206752,17.1732214 L13.2206752,13.2206752 L17.1732214,13.2206752 C17.8506962,13.2206752 18.4,12.6786954 18.4,12 C18.4,11.3261873 17.8494755,10.7793248 17.1732214,10.7793248 L13.2206752,10.7793248 L13.2206752,6.82677856 C13.2206752,6.14930383 12.6786954,5.6 12,5.6 C11.3261873,5.6 10.7793248,6.15052451 10.7793248,6.82677856 Z",
    id: "Clip-2",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRolesAdd);
export default __webpack_public_path__ + "static/media/icon_roles_add.8912c3e2ec67182444e879c2d0165e2b.svg";
export { ForwardRef as ReactComponent };